import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="color-changer"
// Changes the color of the attached element based on key value pairs
export default class extends Controller {

  // Target Defs
  // house: The tr element which contains the row. it has a data-boid to select proper elements on changes.
  static targets = ["house", "publicTitle", "publicTitleLink", "ownerApproval", "publicWebsite"]

  static values = {
    colorMapping: String, // JSON string to parse
    boid: String,
    boLink: String,
  }

  paint(event) {
    const value = event.target.dataset.currentValue;
    const colorMapping = JSON.parse(event.target.dataset.colorMapping);
    event.target.classList.forEach(className => {
      if (className.startsWith("bg-")) {
        event.target.classList.remove(className);
      }
    });
    event.target.classList.add(colorMapping[value]["bg"]);
    event.target.classList.add(colorMapping[value]["text"])
  }

  updateTitle(event) {
    const pt = this.publicTitleTarget;
    const ptLink = this.publicTitleLinkTarget;
    const ownerApprovalCurrentValue = this.ownerApprovalTarget.dataset.currentValue;
    const publicWebsiteCurrentValue = this.publicWebsiteTarget.dataset.currentValue;
    if (ownerApprovalCurrentValue === "approved" && ["approved", "preapproved_llm", "preapproved"].includes(publicWebsiteCurrentValue)) {
      ptLink.href = pt.dataset.publicLink;
    } else {
      ptLink.href = pt.dataset.adminLink;
    }
  }
}
